import { GetOrderServicesResponse } from '@cemex-core/cmx-api';
import { Order } from '@cemex-core/cmx-api/models/order-management/order';
import { combineReducers } from '@ngrx/store';
import { orderItemSorter } from '../../../../shared/utils/order-item-sorter';
import { ReviewActions, ReviewActionTypes } from '../actions/review.actions';

export interface ReviewBaseState {
  draft: DraftState;
}

export interface DraftState {
  orderDraftId: number | null;
  orderDraft: Order | null;
  loaded: boolean;
  cemexPumpServices: GetOrderServicesResponse;
}

export const initialDraftState: DraftState = {
  orderDraftId: null,
  orderDraft: null,
  loaded: false,
  cemexPumpServices: null,
};

export function draftReducer(state = initialDraftState, action: ReviewActions): DraftState {
  switch (action.type) {
    case ReviewActionTypes.SET_DRAFT_ID: {
      return {
        ...state,
        orderDraftId: action.payload.orderDraftId,
      };
    }
    case ReviewActionTypes.LOAD_DRAFT_COMPLETE: {
      const i = action.payload.orderDraft.items ? action.payload.orderDraft.items : action.payload.orderDraft.orderProducts;
      return {
        ...state,
        orderDraft: {
          ...action.payload.orderDraft,
          items: i.sort(orderItemSorter) as any,
        },
        loaded: true,
      };
    }
    case ReviewActionTypes.RESET: {
      return {
        ...initialDraftState,
      };
    }
    case ReviewActionTypes.LOAD_PUMPING_SERVICE_COMPLETE: {
      return {
        ...state,
        cemexPumpServices: action.payload,
      };
    }
    case ReviewActionTypes.RESET_DRAFT: {
      return {
        ...state,
        orderDraft: null,
      };
    }
    default: {
      return state;
    }
  }
}

export const reducers = combineReducers({
  draft: draftReducer,
});
